import * as React from 'react'
import axios from 'axios'
import { UserIdContext, UserIsStaffContext, UsernameContext } from '../App'
import { Link } from 'react-router-dom'

interface IConnect {
    isConnected : any,
    setIsConnected : any
}

//This component manage the Logout of a user. Setting appropriate states and localstorages
export const Logout: React.FunctionComponent<IConnect> = (props) => {

    const {currentUsername, setCurrentUsername} = React.useContext(UsernameContext)
    const {currentUserId, setCurrentUserId} = React.useContext(UserIdContext)
    const {currentUserIsStaff, setCurrentUserIsStaff} = React.useContext(UserIsStaffContext)

    const handleClick = () => {
        axios.post('https://LaurenceBrun.eu.pythonanywhere.com/auth/logout/', {},
    {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    )
    .then(function (response) {
        setCurrentUsername("")
        setCurrentUserId("")
        props.setIsConnected(false)
        setCurrentUserIsStaff(false)
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('username')
        localStorage.removeItem('userId')
        localStorage.removeItem('userIsStaff')
    })
    .catch(function(erreur) {
        console.log(erreur.response)
    })
    }

    if (!props.isConnected) {
        return(
            <div></div>
        )
    }
    else{
        return(
            <div>
                <Link to = "/"><div onClick={handleClick}>Déconnexion</div></Link>
            </div>
        )
    }
}